import './About.css';
import React from 'react';

function About() {
    return (
       <article className='about'>
            <p>
            Oblique Strategies is a lightweight daily writing tool utilizing the prompts and principles of both the Oblique Strategies deck created by Brian Eno and the practice of Morning Pages from Julia Cameron's book the artists way. The goal is to create a place to focus on writing as a practice rather than a matter of output by focusing the user on daily writing goals and de-emphasizing the actual output of their writing.   
            </p>
            <br></br>
            <p>Concept and coding by David Daw</p>
            <p>Design by Nicole Thayer</p>
       </article>
    );
  };

 export default About